import { render, staticRenderFns } from "./ClaimAlerts.vue?vue&type=template&id=70050003&"
import script from "./ClaimAlerts.vue?vue&type=script&lang=js&"
export * from "./ClaimAlerts.vue?vue&type=script&lang=js&"
import style0 from "./ClaimAlerts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports